import { LineItem } from 'line-item';
import { Shelf } from 'shelf';
import { Constants } from 'utils';
class ShelfConfigurator extends HTMLElement {
	connectedCallback() {
		this.levels = [];
		this.lineItems = [];
		this.insertionSequence = [];
		this.placements = [];
		this.success = false;
		this.freeSpaces = [];
		this.isShelfReady = false;
		this.wasShelfFull = false;
		this.isInitializing = false;
		this.bufferSpace = parseFloat(this.dataset.shelfBufferSpace) * 10 || 1;
		this.lidOffset = parseFloat(this.dataset.shelfLidOffset) * 10 || 4;
		this.view = 'FRONT';
		this.shelfForm = this.querySelector('shelf-form');
		this.orderForm = this.querySelector('order-form');
		this.shelfOutput = document.querySelector('shelf-sticky-bar');
		this.resetOrderButton = this.querySelector('[reset-order]');
		this.resetShelfSizesButtons = this.querySelectorAll('[reset-shelf-sizes]');
		this.shelfVisualization = this.querySelector('shelf-visualization');
		this.visualizationViewButtons = this.shelfVisualization.querySelectorAll('button[view]');
		this.shelfForm.addEventListener('shelf-form:set-up', this.onShelfReady.bind(this));
		this.orderForm.addEventListener('order-form:change', this.onOrderFormChange.bind(this));
		this.orderForm.addEventListener('order-form:randomize', this.onRandomFill.bind(this));
		this.resetOrderButton.addEventListener('click', this.onOrderFormReset.bind(this));
		this.resetShelfSizesButtons.forEach((button) => {
			button.addEventListener('click', this.onShelfFormReset.bind(this));
		});
		this.visualizationViewButtons.forEach((button) => {
			button.addEventListener('click', this.onVisualizationViewChange.bind(this));
		});
		// TODO: remove this when not needed
		setTimeout(() => {
			this.initInfoModals();
			this.initShelfFullModal();
			this.loadLocalStorage();
		}, 1000);
	}
	disconnectedCallback() {
		this.shelfForm.removeEventListener('shelf-form:set-up', this.onShelfReady.bind(this));
		// TODO: Remove other event listeners
	}
	generateUrlParams() {
		const shelfData = {
			levels: this.levels,
			isShelfReady: this.isShelfReady,
			lineItems: this.lineItems.map((lineItem) => ({
				variantID: lineItem.variantID,
				quantity: lineItem.quantity,
				color: lineItem.color,
				category: lineItem.category,
				width: lineItem.width,
				height: lineItem.height,
				depth: lineItem.depth,
				imageUrl: lineItem.imageUrl,
			})),
		};
		const jsonString = JSON.stringify(shelfData);
		const searchParams = new URLSearchParams();
		searchParams.set('shelf', jsonString);
		return searchParams;
	}
	initInfoModals() {
		const infoButtons = this.querySelectorAll('[data-modal-id]');
		infoButtons.forEach((button) => {
			const modalId = button.getAttribute('data-modal-id');
			const modalName = button.getAttribute('data-modal-name');
			const modal = new theme.Modals(modalId, modalName, {
				bodyOpenClass: ['modal-open', 'modal-open--shelf-configurator'],
			});
			document.addEventListener('modalOpen.' + modalId, () => {
				this.shelfOutput.hide();
			});
			document.addEventListener('modalClose.' + modalId, () => {
				this.shelfOutput.show();
			});
		});
	}
	initShelfFullModal() {
		this.shelfFullModal = new theme.Modals('ShelfConfigurator-shelf-full', 'shelf-full', {
			bodyOpenClass: ['modal-open', 'modal-open--shelf-configurator'],
		});
		document.addEventListener('modalOpen.ShelfConfigurator-shelf-full', () => {
			this.shelfOutput?.hide();
		});
		document.addEventListener('modalClose.ShelfConfigurator-shelf-full', () => {
			this.shelfOutput?.show();
		});
		const modalAddToCartBtn = this.querySelector('.shelf-full-modal__add-to-cart');
		modalAddToCartBtn?.addEventListener('click', () => this.addToCart(modalAddToCartBtn));
	}
	addToCart(button) {
		if (!this.fitItems?.length) return;
		const payload = this.fitItems.map((item) => ({
			id: parseInt(item.variantID),
			quantity: item.count,
		}));
		button.classList.add('btn--loading');
		fetch(`${Shopify.routes.root}cart/add.js`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
			body: JSON.stringify({ items: payload }),
		})
			.then((res) => res.json())
			.then((data) => {
				button.classList.remove('btn--loading');
				document.dispatchEvent(
					new CustomEvent('ajaxProduct:added', { detail: { product: data, addToCartBtn: button } }),
				);
			})
			.catch((err) => {
				console.error('Cart error:', err);
				button.classList.remove('btn--loading');
				document.dispatchEvent(new CustomEvent('ajaxProduct:error', { detail: { errorMessage: err.message } }));
			});
	}
	updateLocalStorage() {
		// TODO: minimize the data stored in localStorage
		const shelfData = {
			levels: this.levels,
			isShelfReady: this.isShelfReady,
			insertionSequence: this.insertionSequence,
			lineItems: this.lineItems.map((lineItem) => ({
				variantID: lineItem.variantID,
				quantity: lineItem.quantity,
				color: lineItem.color,
				category: lineItem.category,
				width: lineItem.width,
				height: lineItem.height,
				depth: lineItem.depth,
				imageUrl: lineItem.imageUrl,
			})),
		};
		// this.generateUrlParams();
		localStorage.setItem('shelfConfiguratorData', JSON.stringify(shelfData));
	}
	loadLocalStorage() {
		this.isInitializing = true;
		const url = new URL(window.location.href);
		const params = url.searchParams;
		const shelfParam = params.get('shelf');
		// remove the shelf parameter from the URL
		if (params.has('shelf')) {
			params.delete('shelf');
			const newUrl = params.toString() ? `${url.pathname}?${params.toString()}` : url.pathname;
			window.history.replaceState({}, '', newUrl);
		}
		const shelfDataFromParam = shelfParam ? decodeURIComponent(shelfParam) : null;
		const shelfData = shelfDataFromParam || localStorage.getItem('shelfConfiguratorData');
		if (shelfData) {
			try {
				const { levels, isShelfReady, lineItems, insertionSequence } = JSON.parse(shelfData);
				// TODO: Add variable isShelfReady to this class
				if (!Array.isArray(levels) || !Array.isArray(lineItems)) {
					throw new Error('Invalid data format in localStorage');
				}
				levels.length > 0 && this.shelfForm.initWithLocalStorage({ levels, isShelfReady: isShelfReady });
				this.levels = levels;
				this.isShelfReady = isShelfReady;

				if (lineItems.length > 0) {
					this.insertionSequence = Array.isArray(insertionSequence)
						? insertionSequence
						: lineItems.flatMap((li) => Array(li.quantity).fill(String(li.variantID)));
					this.lineItems = lineItems;
					this.orderForm.initWithLocalStorage({ lineItems });
					this.onOrderFormChange({ detail: { lineItems } });
					if (!this.success) {
						this.insertionSequence = [];
						this.lineItems = [];
						this.orderForm.reset();
					}
				}
			} catch (error) {
				console.error('Error parsing shelfConfiguratorData from localStorage:', error);
				localStorage.removeItem('shelfConfiguratorData');
			}
		}
		this.isInitializing = false;
	}

	onOrderFormChange(event) {
		// TODO: MOVE TO ONE FUNCTION
		// TODO: on RESET THIS IS CALLED Ax the amount of line items
		const newLineItems = event.detail.lineItems;
		const oldQtyMap = new Map(this.lineItems.map((li) => [String(li.variantID), li.quantity]));
		const newQtyMap = new Map(newLineItems.map((li) => [String(li.variantID), li.quantity]));
		newQtyMap.forEach((newQty, variantID) => {
			const oldQty = oldQtyMap.get(variantID) || 0;
			for (let i = 0; i < newQty - oldQty; i++) this.insertionSequence.push(variantID);
		});
		oldQtyMap.forEach((oldQty, variantID) => {
			const newQty = newQtyMap.get(variantID) || 0;
			for (let i = 0; i < oldQty - newQty; i++) {
				const idx = this.insertionSequence.lastIndexOf(variantID);
				if (idx !== -1) this.insertionSequence.splice(idx, 1);
			}
		});
		this.lineItems = newLineItems;
		this.initLineItemsObjects();
		this.initImageUrls();
		this.calculatePositions();
		const isShelfFull = this.orderForm.isShelfFull(this.shelf);
		this.shelfVisualization.rerender({
			view: this.view,
			shelf: this.shelf,
			placements: this.placements,
			imageMap: this.imageMap,
		});
		// TODO: REFACTOR THIS
		const fitItemsMap = {};
		this.placements.forEach((placement) => {
			fitItemsMap[placement.variantID] = fitItemsMap[placement.variantID] ? fitItemsMap[placement.variantID] + 1 : 1;
		});
		const fitItems = Object.entries(fitItemsMap).map(([variantID, count]) => ({ variantID, count }));
		this.fitItems = fitItems;

		this.shelfOutput?.initializeLineItems(fitItems, isShelfFull);
		if (isShelfFull && !this.wasShelfFull && !this.isInitializing) {
			this.shelfFullModal?.open();
		}
		this.wasShelfFull = isShelfFull;
		this.updateLocalStorage();
	}
	onRandomFill(event) {
		if (!this.shelf || !this.orderForm) return;
		const selectedCategories = event.detail?.categories || Constants.AUTO_FILLER_ALL;
		const candidates = (this.orderForm.lineItems || [])
			.filter((lineItem) => selectedCategories === Constants.AUTO_FILLER_ALL || selectedCategories.includes(lineItem.category))
			.map((lineItem) => ({
				...lineItem,
				quantity: 0,
				variantID: String(lineItem.variantID),
			}));
		const { lineItems, insertionSequence } = this.shelf.fillShelfRandomly(candidates, {
			maxSteps: 2000,
			rng: Math.random,
			maxBudget: event.detail?.maxBudget || Infinity,
		});
		this.insertionSequence = insertionSequence;
		this.lineItems = lineItems;
		this.orderForm.initWithLocalStorage({ lineItems });
		this.onOrderFormChange({ detail: { lineItems } });
		setTimeout(() => {
			this.shelfVisualization.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}, 200);
		this.updateLocalStorage();
	}

	onOrderFormReset() {
		this.insertionSequence = [];
		this.orderForm.reset();
		this.updateLocalStorage();
	}
	shouldOrderPersist(oldLevels, newLevels) {
		// order should be removed if any level is removed or any level is made smaller
		// making the shelf bigger should keep the order.
		const hasMoreOrEqualLevels = newLevels.length >= oldLevels.length;
		const allOldLevelsPreserved = oldLevels.every((oldLevel) => {
			const matchingNewLevel = newLevels.find((newLevel) => newLevel.index === oldLevel.index);
			const newLevelIsSameOrBigger =
				matchingNewLevel &&
				matchingNewLevel.width >= oldLevel.width &&
				matchingNewLevel.height >= oldLevel.height &&
				matchingNewLevel.depth >= oldLevel.depth;
			return matchingNewLevel && newLevelIsSameOrBigger;
		});
		return hasMoreOrEqualLevels && allOldLevelsPreserved;
	}
	onShelfReady(event) {
		const { levels } = event.detail;

		const shouldOrderPersist = this.shouldOrderPersist(this.levels, levels);
		this.levels = levels;

		this.initShelfObject();
		this.shelfForm.classList.add('hide');
		const atLeastOneCouldFit = this.orderForm.setDimensions({
			maxWidth: this.shelf.maxWidth,
			maxHeight: this.shelf.maxHeight,
			maxDepth: this.shelf.maxDepth,
			bufferSpace: this.shelf.bufferSpace,
			bins: this.shelf.bins,
		});
		this.classList.toggle('shelf-configurator--order-form-empty', !atLeastOneCouldFit);
		this.orderForm.updateLineItemInputs(this.shelf, this.lineItemsObjects);
		this.orderForm.classList.remove('hide');
		this.shelfVisualization.classList.remove('hide');
		this.shelfVisualization.rerender({
			view: this.view,
			shelf: this.shelf,
			placements: this.placements,
			imageMap: this.imageMap,
		});
		if (!shouldOrderPersist) {
			this.orderForm.reset();
		}
		this.shelfOutput?.show();
		this.isShelfReady = true;
		this.updateLocalStorage();
	}
	onShelfFormReset() {
		this.shelfForm.classList.remove('hide');
		this.orderForm.classList.add('hide');
		this.shelfVisualization.classList.add('hide');
		this.shelfOutput?.hide();
		setTimeout(() => {
			this.shelfForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}, 200);
		this.isShelfReady = false;
		this.updateLocalStorage();
	}
	initShelfObject() {
		if (this.levels.length === 0) {
			console.error('No levels defined in shelf form');
			return;
		}
		this.shelf = new Shelf({ ...this.levels[0], bufferSpace: this.bufferSpace, lidOffset: this.lidOffset });
		this.levels.slice(1).forEach((level) => {
			this.shelf.addBin({
				width: level.width,
				height: level.height,
				depth: level.depth,
				binPlacement: level.levelPlacement,
			});
		});
	}
	initLineItemsObjects() {
		this.lineItemsObjects = this.lineItems.map((lineItem) => {
			return new LineItem({
				...lineItem,
				position: {
					x: 0,
					y: 0,
					z: 0,
				},
			});
		});
	}
	initImageUrls() {
		//TODO: handed as color to the line item
		this.imageMap = {};
		this.lineItems.forEach((lineItem) => {
			if (lineItem.imageUrl) {
				this.imageMap[lineItem.variantID] = lineItem.imageUrl;
			}
		});
	}
	onVisualizationViewChange(event) {
		const view = event.target.getAttribute('view');
		this.view = view;
		this.visualizationViewButtons.forEach((button) => {
			button.classList.remove('button--primary');
			button.classList.add('button--secondary');
		});
		event.target.classList.remove('button--secondary');
		event.target.classList.add('button--primary');
		this.shelfVisualization.rerender({
			view,
			shelf: this.shelf,
			placements: this.placements,
			imageMap: this.imageMap,
		});

		this.updateLocalStorage();
	}
	calculatePositions() {
		const result = this.shelf.doesLineItemsFit(this.lineItemsObjects, this.insertionSequence);
		this.placements = result.placements;
		this.success = result.success;
		this.freeSpaces = result.freeSpaces;
		// used to disable the button if no items can fit anymore
		this.orderForm.updateLineItemInputs(this.shelf, this.lineItemsObjects);
		return result.success;
	}
}
customElements.define('shelf-configurator', ShelfConfigurator);
